import { $t } from '@/i18n';
import { defineComponent } from '@vue/composition-api';
import useApproval from '@/pages/notification/useApproval';
export default defineComponent({
    name: 'NotificationEntry',
    methods: {
        gotoNotification() {
            this.$router.push('/notifications/approvals');
        },
    },
    setup() {
        const { getTodoCount, todoCount } = useApproval();
        return { getTodoCount, todoCount };
    },
    created() {
        this.getTodoCount();
    },
    render() {
        return (<div onClick={this.gotoNotification} wj-eid={$t('k_d5973ce4')}>
        {this.todoCount > 0 ? (<a-tooltip title={$t('k_3c94703e', { arg_0: this.todoCount })}>
            <a-badge dot>
              <a-icon type="bell"/>
            </a-badge>
          </a-tooltip>) : (<a-icon type="bell" style="font-size: 16px"/>)}
      </div>);
    },
});
